// extracted by mini-css-extract-plugin
export default {"depositCard":"DepositeCard_depositCard__E4Kup","depositTitle":"DepositeCard_depositTitle__IWmNx","bonus":"DepositeCard_bonus__Ytkqy","free":"DepositeCard_free__GUyLy"};